'use client';
import ShieldKeyholdGradient from '@public/svg/shield-keyhole-gradient.svg?component';
import clsx from 'clsx';

import { Alter25Button } from '@/components/alter25/Alter25Button';
import { Alter25QADropDowns } from '@/components/alter25/Alter25QADropDowns';
import { privacyGuaranteed } from '@/data/shop/swab-kit/privacy-guaranteed.data';

interface ProductReviewProps {
  className?: string;
}

export const ShopSwabKitPivacyGuaranteed: React.FC<ProductReviewProps> = ({ className }) => {
  return (
    <div className={clsx(className)}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-20 gap-y-10">
        <div
          className={clsx(
            'lg:w-auto md:w-[512px] lg:justify-self-auto md:justify-self-center',
            'privacy-guard-shield rounded-2xl',
            'flex justify-center items-center'
          )}
        >
          <ShieldKeyholdGradient className="w-[42%] h-[42%]" />
        </div>
        <div>
          <h3 className={clsx('font-light mb-4', 'responsive-text-24-40')}>Privacy Guaranteed</h3>
          <div
            className={clsx(
              'font-light mb-8',
              'text-base leading-[24px]',
              'md:text-lg leading-[27px]'
            )}
          >
            Your DNA privacy is our utmost priority. We employ rigorous security measures to ensure
            your data remains confidential and protected throughout your journey with Alter.
          </div>
          <Alter25QADropDowns qas={privacyGuaranteed} className="mb-8" noPreopen />
          <Alter25Button
            text="Privacy Policy"
            href="/legal/privacy-policy"
            size="lg"
            style="white"
            arrow
          />
        </div>
      </div>
    </div>
  );
};
